/** Ficheiro de Configuração de Acessos Remotos */

if (process.env.REACT_APP_MODE === 'production') console.log = function () { };

const webSiteTitle = 'Estância de Ski - Serra da Estrela'

const webSiteAdress = 'Estrada Nacional 339, Apartado 332 - 6200-073 Covilhã, Portugal'

const companycode = '0000000';

const contactFrom = process.env.REACT_APP_API_EMAIL_CONTACT;

// ########################### CONFIG ##################################

const EMAIL_BODY_BACKGROUND_COLOR = ' #F7F7F7'
const EMAIL_TEXT_SIZE = ' 14px'
const EMAIL_TEXT_LINE_HEIGHT = ' 24px'
const EMAIL_TEXT_COLOR = ' #444444'
const EMAIL_BACKGROUND_COLOR = ' #FFFFFF'
const FOOTER_EMAIL_TEXT_SIZE = ' 12px'
const FOOTER_EMAIL_TEX_LINE_HEIGHT = ' 20px'
const FOOTER_EMAIL_COLOR = 'transparent'
const FOOTER_EMAIL_TEXT_COLOR = '#656565'

//const FOOTER_EMAIL_COLOR = '#333333'

console.log('HOSTS---------------------------------------------------------')

console.log('HOSTS APPLICATION_URL:', process.env.REACT_APP_PRINCIPAL_URL)

console.log('HOSTS APPLICATION_SITE_URI:', process.env.REACT_APP_PRINCIPAL_URL)
const WEB_SITE_URI = process.env.REACT_APP_SITE_URI

console.log('HOSTS APPLICATION_BACKOFFICE_URI:', process.env.REACT_APP_GEST_URI)
const WEB_BACKOFFICE_URI = process.env.REACT_APP_GEST_URI

console.log('NODE_ENV SIMCore_API:', process.env.REACT_APP_API_URL)
const SIMCore_API = process.env.REACT_APP_API_URL;

console.log('NODE_ENV APP_REPO_FOLDER:', process.env.REACT_APP_REPO_FOLDER)
const APP_REPO_FOLDER = process.env.REACT_APP_REPO_FOLDER

console.log('NODE_ENV REPO URL:', process.env.REACT_APP_REPO_URL)
const REPO = process.env.REACT_APP_REPO_URL

console.log('NODE_ENV SIMCore_API_MAIL:', process.env.REACT_APP_API_EMAIL_URL)
const SIMCore_API_MAIL = process.env.REACT_APP_API_EMAIL_URL


console.log('NODE_ENV EMAIL_WEB_SITE_URL:', process.env.REACT_APP_SITE_URL)
console.log('NODE_ENV EMAIL_WEB_SITE_URL_REAL :', process.env.REACT_APP_SITE_URL_REAL)
const EMAIL_WEB_SITE_URL = process.env.REACT_APP_SITE_URL_REAL

console.log('NODE_ENV EMAIL_WEB_BACKOFFICE_URL:', process.env.REACT_APP_GEST_URL)
console.log('NODE_ENV EMAIL_WEB_BACKOFFICE_URL_REAL:', process.env.REACT_APP_BACKOFFICE_URL_REAL)
const EMAIL_WEB_BACKOFFICE_URL = process.env.REACT_APP_BACKOFFICE_URL_REAL


// #####################################################################




//Begin exporting all variables
module.exports = {
    SIMCore_API,
    SIMCore_API_MAIL,

    EMAIL_BODY_BACKGROUND_COLOR,
    EMAIL_TEXT_SIZE,
    EMAIL_TEXT_LINE_HEIGHT,
    EMAIL_TEXT_COLOR,
    EMAIL_BACKGROUND_COLOR,
    FOOTER_EMAIL_TEXT_SIZE,
    FOOTER_EMAIL_TEX_LINE_HEIGHT,
    FOOTER_EMAIL_COLOR,
    FOOTER_EMAIL_TEXT_COLOR,
    //FOOTER_EMAIL_COLOR,

    REPO,
    APP_REPO_FOLDER,
    WEB_SITE_URI,
    WEB_BACKOFFICE_URI,
    EMAIL_WEB_SITE_URL,
    EMAIL_WEB_BACKOFFICE_URL,

    //COMENTAR E VERIFICAR SE FALTA SUBSTITUIR EM ALGUM LADO
    //webSiteURL,
    //emailWebSiteURL,
    //emailBackofficeURL,
    //backofficeURL,

    webSiteTitle,
    webSiteAdress,
    companycode,
    contactFrom
};





